export default __webpack_public_path__ + "static/media/4.044f8b19.png";